import React from "react";
import { useLabels } from "../../../hooks/useLabels";

import { IconButton } from "../../icon-button";

import { Header } from "../header";

import { labels } from "./labels";

function PhotoInfoHeaderLeft({ onClose }: { onClose(): void }) {
	return (
		<>
			<IconButton iconName="cross" onClick={() => onClose()} />
		</>
	);
}

export function PhotoInfoHeader({ onClose }: { onClose(): void }) {
	const [[informationLabel]] = useLabels([labels.information]);

	return <Header left={<PhotoInfoHeaderLeft onClose={onClose} />}>{informationLabel}</Header>;
}
